"use client";

import { useEffect } from "react";
import ErrorPage from "@/components/entities/error";

export default function Error({
  error,
}: {
  error: Error & { digest?: string; status?: number; code?: number | string };
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <ErrorPage code={error.status ?? error.code ?? 500} text={error.message} />;
}
